import React, { useState } from 'react';
import parse from "html-react-parser"
import Request from '../Request/Request';
import Input from '../App/Input';
//import Textarea from '../App/Textarea';

export default function Booking( props ) {

	const [ booked, setBooked ] = useState( false ) 

	//console.log( props )

	if ( booked ) { 
		return <>
			{ parse( props.props.content || '' ) }
		</>
	} else {
		return <>
			<div style={{ fontSize:'18px', fontWeight:'700' }} >
				<Input id="name" title="Name" mandatory values={ props.formValues } handleChange={ props.handleChange } />
				<Input id="email" title="Email address" mandatory values={ props.formValues } handleChange={ props.handleChange } />
				<Input id="phone" title="Phone or WhatsApp" mandatory values={ props.formValues } handleChange={ props.handleChange } />
				<Input id="notes" title="Notes" mandatory values={ props.formValues } handleChange={ props.handleChange } />
				<button 
					className="button"
					style={{ 
						marginTop:20, 
					}} 
					onClick={ () => { 
						const data = { 
							cruise_id:props.cruise.id, 
							price:props.total, 
							...props.formValues, 
							...props.cabins 
						}
						Request.post( 'book', data, result => setBooked( true ) )
					} }
				>
					Book Now
				</button>
			</div>
		</>
	}
}
